import { StyledEngineProvider } from "@mui/material";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";

ReactDOM.render(

  <StyledEngineProvider injectFirst>
    <App />
  </StyledEngineProvider>
  ,
  document.getElementById('root')
);

